var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasExportAccess
    ? _c(
        "button",
        {
          staticClass: "d-flex align-items-center",
          attrs: { type: "button" },
          on: { click: _vm.importCsv },
        },
        [
          _c("i", { staticClass: "me-2 bi-download" }),
          _vm._v("\n    Import CSV\n"),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }